import c from 'classnames';
import { Button } from '../Button';
import { Typography } from '../Typography';
import { BannerColor } from './Banner';
import styles from './SimpleBanner.module.css';
import { SimpleBannerProps } from './types/SimpleBanner.types';

export function SimpleBanner({
  content,
  icon,
  color,
  action,
}: SimpleBannerProps) {
  const colorStyles: Record<BannerColor, string> = {
    purple: styles.purple,
    orange: styles.orange,
    lightPurple: styles.lightPurple,
  };

  return (
    <div className={c(styles.container, colorStyles[color])}>
      {icon && <div className={styles.iconContainer}>{icon({})}</div>}
      <Typography variant='body-s' className={styles.content}>
        {content}
      </Typography>
      {action && (
        <Button
          className={styles.action}
          label={action.label}
          onClick={action.onClick}
          color={color}
          size='small'
        />
      )}
    </div>
  );
}
